// src/pages/Settings/company/taskChecklist/index.js
// Settings section listing Task Checklist templates with edit / new-template
// entry points into the dedicated builder.

import React, { useEffect, useMemo } from "react";
import { Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import SettingsPanel from "../../components/SettingsPanel";
import { checkListTemplateListActive } from "../../../../store/actions";
import HandleDateTime from "../../../../Components/Common/HandleDateTime";

export default function TaskChecklistSettings() {
  const dispatch = useDispatch();

  const { templatesRaw, loading } = useSelector((state) => ({
    templatesRaw: state.Checklist.checklistTemplateActive,
    loading: state.Checklist.checklistTemplateLoading,
  }));

  useEffect(() => {
    dispatch(checkListTemplateListActive());
  }, [dispatch]);

  const templates = useMemo(
    () => templatesRaw?.taskchecklisttemplate_list || [],
    [templatesRaw]
  );

  return (
    <SettingsPanel
      title="Task Checklist"
      description="Templates your team completes on tasks. Build the form and PDF layout in the dedicated builder."
      actions={
        <>
          <a
            href="/checklist-templates"
            target="_blank"
            rel="noreferrer"
            className="btn page-shell__ghost-button"
            title="Open the full Checklist Templates manager in a new window"
          >
            <i className="ri-external-link-line align-bottom me-1" /> Open manager
          </a>
          <Link to="/checklist-builder" className="btn page-shell__add-button">
            <i className="ri-add-line align-bottom me-1" /> New template
          </Link>
        </>
      }
    >
      <Table hover responsive className="align-middle mb-0">
        <thead className="table-light">
          <tr>
            <th style={{ width: 70 }}>ID</th>
            <th>Title</th>
            <th>Description</th>
            <th style={{ width: 170 }}>Last updated</th>
            <th style={{ width: 110 }} className="text-end">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {templates.map((t) => (
            <tr key={t.Id}>
              <td>{t.Id}</td>
              <td className="fw-semibold">{t.Title}</td>
              <td className="text-muted">{t.Description}</td>
              <td>
                {t.UpdatedDateTime ? HandleDateTime(t.UpdatedDateTime) : "—"}
              </td>
              <td className="text-end">
                <Link
                  to={`/checklist-builder/${t.Id}`}
                  className="btn btn-sm btn-light"
                  title="Edit template"
                >
                  <i className="ri-pencil-line" /> Edit
                </Link>
              </td>
            </tr>
          ))}
          {!loading && templates.length === 0 && (
            <tr>
              <td colSpan={5} className="text-center text-muted py-4">
                No templates yet. Click “New template” to build your first.
              </td>
            </tr>
          )}
          {loading && (
            <tr>
              <td colSpan={5} className="text-center text-muted py-4">
                Loading…
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </SettingsPanel>
  );
}
